import { defineMessages } from 'react-intl';

export default defineMessages({
  salutationText: {
    id: 'LOGIN_KNOWN_USER_TEXT',
    defaultMessage: 'Schön, dass Sie da sind,',
  },
  salutationMale: {
    id: 'LOGIN_KNOWN_USER_MALE',
    defaultMessage: 'Herr {lastName}',
  },
  salutationFemale: {
    id: 'LOGIN_KNOWN_USER_FEMALE',
    defaultMessage: 'Frau {lastName}',
  },
  partnerAuthIntroduction: {
    id: 'LOGIN_OAUTH_INFO_PARAGRAPH',
    defaultMessage:
      'Bitte loggen Sie sich mit Ihren XING Zugangsdaten ein und gewähren Sie der Anwendung {application} Zugriff auf Ihre bei XING gespeicherten Daten.',
  },
  buttonLabel: {
    id: 'LOGIN_KNOWN_USER_LOGIN_BUTTON',
    defaultMessage: 'Jetzt einloggen',
  },
  notYouLink: {
    id: 'LOGIN_NOT_ME',
    defaultMessage: 'Das sind Sie nicht? Benutzer wechseln',
  },
  forgotPasswordLabel: {
    id: 'LOGIN_FORGOT_PASSWORD',
    defaultMessage: 'Forgot your password?',
  },
  postRecoveryTitle: {
    id: 'LOGIN_RECOVERY_SUCESSFUL_RESET_TITLE',
    defaultMessage: 'Prima, Sie haben ein neues Passwort',
  },
  passwordPlaceholder: {
    id: 'LOGIN_PASSWORD_PLACEHOLDER',
    defaultMessage: 'Sesam, öffne dich ...',
  },
  title: {
    id: 'LOGIN_NEW_TITLE',
    defaultMessage: 'Willkommen zurück',
  },
  emailLabel: {
    id: 'LOGIN_NEW_EMAIL_LABEL',
    defaultMessage: 'E-Mail / Handynummer',
  },
  passwordLabel: {
    id: 'LOGIN_NEW_PASSWORD_LABEL',
    defaultMessage: 'Passwort',
  },
  submitLabel: {
    id: 'LOGIN_NEW_SUBMIT_TEXT',
    defaultMessage: 'Jetzt einloggen',
  },
  registerNow: {
    id: 'LOGIN_NEW_REGISTER_TEXT',
    defaultMessage: 'Noch kein XING-Mitglied? Jetzt kostenlos registrieren.',
  },
  problemsLoginInLabel: {
    id: 'LOGIN_NEW_PROBLEMS_TEXT',
    defaultMessage: 'Probleme beim Einloggen?',
  },
  rememberMe: {
    id: 'LOGIN_NEW_REMEMBER_ME_TEXT',
    defaultMessage: 'Eingeloggt bleiben',
  },
});
